"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiMerchantResponseDto = void 0;
const billing_core_supplier_business_type_enum_1 = require("../../../../billing-core/billing-core-supplier/types/enums/billing-core-supplier-business-type.enum");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BillingApiMerchantResponseDto = class BillingApiMerchantResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id провайдера",
  format: "uuid",
  readOnly: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiMerchantResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Наименование провайдера",
  readOnly: true,
  example: "Stripe"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiMerchantResponseDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Примечание, например Test mode",
  readOnly: true,
  example: "Test mode",
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiMerchantResponseDto.prototype, "note", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Указывает на тестовый режим платежей по тестовым картам",
  type: Boolean,
  readOnly: true,
  nullable: true,
  required: false
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiMerchantResponseDto.prototype, "testMode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Поддерживаемые страны (необязательно). Если не указано,
    то поддерживает все страны кроме unSupportCountries.`,
  readOnly: true,
  type: String,
  isArray: true,
  pattern: '^[A-Z]{2}$',
  example: ["RU"]
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiMerchantResponseDto.prototype, "supportedCountries", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Неподдерживаемые страны (необязательно). Если не указано,
    то поддерживает, те, которые указаны в supportCountries.`,
  readOnly: true,
  type: String,
  isArray: true,
  pattern: '^[A-Z]{2}$',
  example: ["RU"]
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiMerchantResponseDto.prototype, "unSupportCountries", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Страны для которых поддерживаются выплаты`,
  readOnly: true,
  type: String,
  isArray: true,
  pattern: '^[A-Z]{2}$',
  example: ["RU"]
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiMerchantResponseDto.prototype, "payoutSupportCountries", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Виды занятости поддерживаемые при регистрации бенефициара у провайдера`,
  readOnly: true,
  enum: Object.values(billing_core_supplier_business_type_enum_1.BillingCoreSupplierBusinessTypeEnum),
  isArray: true
}), (0, class_transformer_1.Expose)(), __metadata("design:type", Array)], BillingApiMerchantResponseDto.prototype, "allowBusinessType", void 0);
BillingApiMerchantResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiMerchantResponseDto);
exports.BillingApiMerchantResponseDto = BillingApiMerchantResponseDto;
